import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=4984b2df&scoped=true&lang=pug"
import script from "./FileUpload.vue?vue&type=script&lang=js"
export * from "./FileUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4984b2df",
  null
  
)

export default component.exports